var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAe = function SvgAe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "matrix(1.3333 0 0 1 -85.333 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h192v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 340.06h576V512H192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M192 172.7h576v169.65H192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00732f",
    d: "M192 0h576v172.7H192z"
  }))));
};
export default SvgAe;